import { render, staticRenderFns } from "./ReleaseView.vue?vue&type=template&id=58e81a74&scoped=true"
import script from "./ReleaseView.vue?vue&type=script&lang=js"
export * from "./ReleaseView.vue?vue&type=script&lang=js"
import style0 from "./ReleaseView.vue?vue&type=style&index=0&id=58e81a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e81a74",
  null
  
)

export default component.exports